import { defineMessages } from 'react-intl';

export default defineMessages({
    continueText: {
        id: 'ml.agent.quoteandbind.ho.disclosureToQuote.We\'ll review your quote next',
        defaultMessage: 'We\'ll {reviewYourQuote} next'
    },
    reviewYourQuote: {
        id: 'ml.agent.quoteandbind.ho.disclosureToQuote.review your quote',
        defaultMessage: 'review your quote'
    },
    somethingWentWrong: {
        id: 'ml.agent.quoteandbind.ho.disclosureToQuote.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
});